// extracted by mini-css-extract-plugin
export default {"buttonImportInDesign":"ButtonImportInDesign_buttonImportInDesign__MNk3K"};